import React, { useEffect, useState } from "react";
import Sidebar from "../Side/Sidebar";
import Topbar from "../Side/Topbar";
import AOS from "aos";
import "aos/dist/aos.css";
import AdminSidebar from "../Side/AdminSidebar";
import { useAuth } from "../Auth/AuthContext";
import AdsTxtContent from "../AdsTxtConfiguration/AdsTxtContent";

import AssignedAdsCode from '../AdsTxtConfiguration/AssignedAdsCode';

const AdsCodeConfiguration = () => {
    const { authState } = useAuth();
    const role = authState.roles;
    const admin = role === "Admin";
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => setIsModalOpen(false); // Ensure this function is defined
    return (
        <div className="min-h-screen flex flex-col md:flex-row">
            {/* Sidebar */}
            {admin ? <AdminSidebar /> : <Sidebar />}

            {/* Main Content */}
            <div className="flex-1 bg-gray-100">
                <div className="flex-1 flex flex-col">
                    <Topbar />

                    <main className="pt-[100px] px-4">
                        <div className="mt-6">
                            {/* Show button only if admin */}
                            {admin && (
                                <button
                                    onClick={handleOpenModal}
                                    className="bg-blue-500 text-white px-5 py-2 rounded-lg hover:bg-blue-600 transition"
                                >
                                    Assign Ads Code
                                </button>
                            )}

                            {/* Assigned Ads Code Modal */}
                            {modalIsOpen && (
                                <AssignedAdsCode
                                    isOpen={modalIsOpen}
                                    onClose={handleCloseModal} // Pass correct close function
                                />
                            )}

                            {/* Ads Txt Content */}
                            <AdsTxtContent isAdCode={true} />
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default AdsCodeConfiguration;
